import React, { useEffect, useState, useCallback, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import FlatFileUpload from 'components/sales/bulkUpload/FlatFileUpload';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const RenewalListing = ({
  getRenewalListingList,
  siteListData,
  getSiteFilters,
  siteFilters,
  UploadFlat,
  history,
}) => {
  const headers = [
    'Contract Id',
    'Site Type',
    'Client Name',
    'Created By',
    'Requested On',
    // 'Site Status',
    'Contract Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isbulk, setIsbulk] = useState(false);
  const [isUploaded, setIsuploaded] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [role, setRole] = useState('')

  const sampleData = {
    file_url: fileUrl,
    // 'https://parkqa.kelltontech.net/download_sample/Flat_List_Format.xls',
  };

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("baSiteCont") &&
        localStorage.getItem("baSiteCont")
    );
    if(installationCont){
      localStorage.setItem("baSiteList", JSON.stringify(""));
      localStorage.setItem("baSiteCont", 0);
    }

    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setRole(roles[0].pivot.role_id);
      })();
    }, 0);

  }, []);

  const getList = useCallback(async () => {
    setIsLoading(true);
    const getcontractFilter = await JSON.parse(
      localStorage.getItem("baSiteList") &&
        localStorage.getItem("baSiteList")
    );
    setIsLoading(true);
    if(getcontractFilter){
      await getRenewalListingList(getcontractFilter);
    }else{
      await getRenewalListingList();
    }
    // await getRenewalListingList(null, currentPage);
    setIsLoading(false);

  }, [getRenewalListingList, currentPage]);

  useEffect(() => {
    if (getRenewalListingList !== null) getList();
  }, [getRenewalListingList, getList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {
    const actions = [
      {
        name: 'View Details',
        link: '/dashboard/brand-activation/site-details',
      }
    ];

    const tableData = [
      'lead_id',
      'site_id',
      'contract_id',
      'site_type',
      'client_name',
      'created_by',
      'created_on',
      'status',
    ];
    if (siteListData && siteListData.resultSets) {
      const data = siteListData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          element.status_id == 8 ?
          {
            // Status: element.status,
            Action:
              [
                { name: 'View Details', link: '/dashboard/contract-details/'+element.contract_id },
                {name: "Edit Contract", link: '/dashboard/edit-renew-contract/' + element.contract_id},
              ]
          } :
            {
              // Status: element.status,
              Action:
                [
                  { name: 'View Details', link: '/dashboard/contract-details/'+element.contract_id }
                ]
            }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          // obj['manage_id'] = obj['lead_id'];
          obj['id'] = obj['lead_id']; // Assign new key
          delete obj['lead_id'];
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("baSiteList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getRenewalListingList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
        <>
          <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
          >
            <img src={Images.Filter} alt="" />
            {localization.showFilters}
          </Button>
        </>
    );
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getRenewalListingList(filterData, val.selected + 1);
    // let filter = filterData === null ? null : filterData;
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.renewlisting}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={siteListData && siteListData.resultSets}
        setIsbulk={setIsbulk}
        setFileUrl={setFileUrl}
        srNo={siteListData?.from}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters?.site_types ? siteFilters : null}
        siteFilters
      />

    </Layout>
  );
};

export default RenewalListing;
